import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Header from './components/Header';
import Career from './components/Career';
import Fitness from './components/Fitness';
import Faith from './components/Faith';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import data from './data.json';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { BrowserRouter } from 'react-router-dom';

function App() {
  // Theme state and toggle function
  const [mode, setMode] = useState('dark');
  const toggleTheme = () =>
    setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

  const theme = createTheme({
    palette: {
      mode,
      ...(mode === 'light'
        ? {
            background: { default: '#f7f9fc', paper: '#ffffff' },
            primary: { main: '#2C5364' },
            text: { primary: '#000000', secondary: '#555555' },
          }
        : {
            background: { default: '#121212', paper: '#1e1e1e' },
            primary: { main: '#90caf9' },
            text: { primary: '#ffffff', secondary: '#bbbbbb' },
          }),
    },
    typography: {
      allVariants: {
        color: mode === 'light' ? '#000000' : '#ffffff',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          {/* Layout wraps the NavigationBar and an Outlet for pages */}
          <Route
            path="/"
            element={<Layout mode={mode} toggleTheme={toggleTheme} />}
          >
            <Route index element={<Header mode={mode} data={data} />} />
            <Route
              path="career"
              element={
                <Career
                  careerBio={data.careerBio}
                  skills={data.skills}
                  experience={data.experience}
                  education={data.education}
                />
              }
            />
            <Route path="faith" element={<Faith />} />
            <Route path="fitness" element={<Fitness />} />
            <Route path="gallery" element={<Gallery />} />
            <Route
              path="contact"
              element={<Contact contact={data.contact} />}
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
